import { ParsedUrlQuery } from 'querystring';

import { AuthRoutes } from 'routes';

// /authenticate is mid sign-in while it holds a login token, or an admin pass, which signs in
// without one. Routing and profile loading hold off until it finishes either way.
export const isAuthenticatingRoute = (pathname: string, query: ParsedUrlQuery | undefined): boolean =>
  pathname === AuthRoutes.Authenticate && Boolean((query?.token && query?.stytch_token_type) || query?.adminGrant);
